import { localStorageKeys } from "../config.management";

import { removeAuthenticationCookies } from "./cookies/removeAuthenticationCookies";

export function removeTokensAndLocalStorageItems() {
    removeAuthenticationCookies();
    localStorage.removeItem(localStorageKeys.notifications);
}
